import { render } from "./Pos.vue?vue&type=template&id=d899501a&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"

import "./Pos.vue?vue&type=style&index=0&id=d899501a&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/MISTOCK/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d899501a"]])

export default __exports__